import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { FileDocumentsSystemModel }
from '../../models/configuration/file-documents-system.model';



import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class
GetFileDocumentsSystemUseCase
implements UseCase<
void,
FileDocumentsSystemModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        
    ):
    Observable<FileDocumentsSystemModel> {

        return this.repository
            .getFileDocumentsSystem(
                
            );
    }
}